module.exports = __webpack_public_path__ + "media/images/eu1000-3956732b068f009da04110c99e007944.svg";